<template lang="pug">
  .access.user-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.modal__title {{formTitle}}
        .edit-select
          select.select(@change="changeEditSelect")
            option(v-for="item in tabs" :key="Object.keys(item)[0]" :value="item") {{ Object.values(item)[0] }}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
          customClass="tabs_no-border"
        )
      slot
        e-form(:formValidator="formValidator" formClass="modal__body")
          // ОБЩИЕ СВЕДЕНИЯ
          .body-flex(v-show="tabView === 'tab1'").tab1
            .modal__row
              .modal__col
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Настройки аккаунта")
                  template(slot="body")
                    e-form-group(
                      name="fullname"
                      inputType="input"
                      label="ФИО"
                      :model="fields"
                      tabView="tab1"
                      autocomplete="off"
                      :required="true"
                    )
                    e-form-group(
                      name="user_group_id"
                      inputType="select"
                      label="Группа"
                      :model="fields"
                      :options="roles"
                      tabView="tab1"
                      :required="true"
                    )
                    e-form-group(
                      name="username"
                      inputType="input"
                      label="Логин"
                      :model="fields"
                      tabView="tab1"
                      :required="true"
                    )
                    e-form-group(
                      name="email"
                      inputType="input"
                      label="E-mail"
                      :model="fields"
                      :required="true"
                      tabView="tab1"
                      validationRule="email"
                    )

                    e-form-group(
                      name="activated"
                      inputType="select"
                      label="Активность"
                      :model="fields"
                      :options="activeOptions"
                      tabView="tab1"
                      :required="true"
                    )

                    e-form-group(
                      v-if="hasSessionField"
                      name="session_limit"
                      inputType="select"
                      label="Количество параллельных сеансов"
                      :model="fields"
                      tabView="tab1"
                      :required="true"
                      :options="sessions"
                    )

              .modal__col
                accordion(:active="true")
                  template(slot="header")
                    e-form-subtitle(text="Личные данные")
                  template(slot="body")
                    e-form-group(
                      name="department"
                      inputType="input"
                      label="Отдел"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="position"
                      inputType="input"
                      label="Должность"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="phone"
                      inputType="input"
                      label="Рабочий телефон/Skype"
                      :model="fields"
                      tabView="tab1"
                    )
                    e-form-group(
                      name="mobile_phone"
                      inputType="input"
                      label="Мобильный телефон"
                      :model="fields"
                      tabView="tab1"
                      mask="+7(###) ###-##-##"
                    )
                    e-form-group(
                      name="birth_date"
                      inputType="calendar"
                      label="Дата рождения"
                      :model="fields"
                      type="date"
                      tabView="tab1"
                    )

              .modal__col
                div(v-if="userPhoto").image
                  img(:src="userPhoto")
                div(v-else).image
                  img(src="~images/user-img-default.svg")
                e-form-group(
                  v-if="hasUserGeoObjects"
                  name="geoObjects"
                  inputType="suggestion[]"
                  label="Видимые муниципальные образования"
                  :model="fields"
                  tabView="tab1"
                  :options="mosOptions"
                  :enableSelectAll="true"
                ).mos-selector
                e-form-group(
                  name="responsibleGeoObjects"
                  inputType="suggestion[]"
                  label="Уполномоченный сотрудник в муниципальном образовании"
                  :model="fields"
                  tabView="tab1"
                  :options="mosOptions"
                  :enableSelectAll="true"
                ).mos-selector

          .body-flex(v-if="tabView === 'tab2'")
            div.body.body-table
              div.mt-40
                e-user-files(
                  :endpoint="getFilesEndpoint"
                  :downloadFile="downloadFile"
                )

          div.tabs-wrapper(v-if="tabView === 'changePassword'")
            button(
              v-if="confirmedPassword && $route.name==='access.users.update'"
              @click="sendNewPassword()"
            ).user-button.user-button--send {{'Отправить ссылку на почту пользователя'}}
          e-modal(
            v-if="showConfirmModal"
            @close="closeConfirmPassword"
            @confirm="confirmSaveForm"
            title="Подтверждение пароля"
            saveBtnLabel="Подтвердить"
            :autoHeight="true"
          )
            slot
              .confirm
                .confirm__field(:class="{'confirm__field_error': errors.password}")
                  label.confirm__label Текущий пароль*
                  input.input(v-model="password" type="password" @input="inputField('password')")
                  .confirm__error(v-if="errors.password" ) {{errors.password}}
                .confirm__field(:class="{'confirm__field_error': errors.repeatPassword}")
                  label.confirm__label Подтверждение пароля*
                  input.input(v-model="repeatPassword" type="password"  @input="inputField('repeatPassword')")
                  .confirm__error(v-if="errors.repeatPassword" ) {{errors.repeatPassword}}
</template>

<script>
import { atu, access } from '@/api/api-endpoints'
import hasMixin from '@/mixins/has-mixin'
import { sessionsItems } from '@/config/config'
import UserProfileChangePassword from '@/app/account/components/user-profile-change-password'
import adminForm from './mixins/admin-form'

export default {
  components: { UserProfileChangePassword },
  mixins: [adminForm, hasMixin],
  data() {
    return {
      tabView: 'tab1',
      fields: {
        activated: 1,
        is_active: true,
        role: '',
        fullname: '',
        username: '',
        password: '',
      },
      sessions: sessionsItems,
      confirmedPassword: false,
      showConfirmModal: false,
      password: '',
      repeatPassword: '',
      errors: {
        password: '',
        repeatPassword: '',
      },
    }
  },
  computed: {
    tabs() {
      if (this.$route.params.id) {
        const tabs = [{ tab1: 'Общие сведения' }, { tab2: 'Файлы' }]

        if (this.hasUserChangePassword) {
          tabs.push({ changePassword: 'Смена пароля' })
        }

        return tabs
      }
      return [{ tab1: 'Общие сведения' }]
    },
    formTitle() {
      if (this.fields && this.fields.id) {
        return this.fields.fullname
      }
      return this.$translate('Добавление нового пользователя')
    },
  },
  watch: {
    tabView: function () {
      if (this.tabView === 'changePassword') {
        this.showConfirmModal = true
      }
    },
  },
  methods: {
    update() {
      adminForm.methods.update.call(this)
    },
    getMOEndpoint() {
      return atu.atuObjects({ query: { 'per-page': -1 } })
    },
    // send post for correct change status and avatar
    getStoreAction() {
      return 'createModel'
    },
    getRolesUrl() {
      return access.groups()
    },
    getDeleteUrl(id) {
      return access.userDelete(id)
    },
    getUpdateOrCreateUrl() {
      return access.userUpdateOrCreate(this.$route.params.id)
    },
    getItemEndpoint(route) {
      if (!route.params.id) {
        return null
      }
      return access.userById(route.params.id)
    },
    closeConfirmPassword() {
      this.tabView = 'tab1'
      this.showConfirmModal = false
      this.confirmedPassword = false
    },
    inputField(field) {
      this.errors[field] = ''
    },
    confirmSaveForm() {
      const username = this.$store.getters.userData.username
      const password = this.password
      const repeatPassword = this.repeatPassword
      if (password === '') {
        this.errors.password = 'Пожалуйста, введите пароль'
      }
      if (repeatPassword === '') {
        this.errors.repeatPassword = 'Пожалуйста, введите подтверждение пароля'
      }
      if (password !== repeatPassword) {
        this.errors.repeatPassword = 'Пароли не совпадают'
      }
      if (password && repeatPassword && password === repeatPassword) {
        this.$store
          .dispatch('userLogin', {
            username: username.trim(),
            password: password.trim(),
          })
          .then(() => {
            this.showConfirmModal = false
            this.password = ''
            this.repeatPassword = ''
            this.confirmedPassword = true
          })
          .catch(() => {
            this.errors.password = 'Введен неправильный пароль'
            this.errors.repeatPassword = 'Введен неправильный пароль'
          })
      }
    },
    async sendNewPassword() {
      this.$bar.start()
      await this.$store.dispatch('createModel', {
        url: access.changePassword(this.$route.params.id),
        data: this.$route.params.id,
      })
      this.$bar.finish()
      this.showOnSuccess(
        this.$translate('Ссылка для восстановления \n пароля была отправлена')
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.tabs-wrapper {
  padding: 15px;
}
</style>
